// extracted by mini-css-extract-plugin
export default {"buttons":"chartsButtons_buttons__Wz91S","button":"chartsButtons_button__tTyVi"};